<template>
  <div class="item-container">
    <div class="check-container">
      <a-radio
        name="vehicle-check"
        v-model:checked="checked"
        @click="handleChecked"
      ></a-radio>
    </div>

    <div class="img-container p-img-container">
      <img
        @load="calculateImg"
        alt="pic"
        v-if="getImgSrc()"
        :src="getImgSrc()"
      />
      <div v-else class="no-img">{{ $t('common.no_img') }}</div>
    </div>

    <div class="item-info">
      <div class="name j-might-overflow">
        {{ $t(vehicle.vehicleName) }}
      </div>

      <div class="detail" @click="handleImg">
        <DetailIcon class="icon" />{{ $t('part.detail') }}
      </div>
    </div>

    <div class="item-action">
      <a-button class="j-outline-btn1 j-height-auto" @click="handleCatalog">{{
        $t('part.parts_catalog')
      }}</a-button>
      <a-button
        class="j-outline-btn1 j-height-auto"
        @click="handleMovingPart"
        >{{ $t('part.fast_moving_parts') }}</a-button
      >
    </div>

    <PreviewImageModal
      @after-close="handleAfterImgModalClose"
      v-if="showPreviewModal"
      :images="previewImg"
      :isAttributeImg="true"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { baseFileUrl } from '@/utils/constants';
import DetailIcon from '@/components/icons/DetailIcon.vue';
import PreviewImageModal from '@/components/preview-image/PreviewImageModal.vue';

interface PartVehicleItemProps {
  previewImg: string[];
  [key: string]: any;
}

export default defineComponent({
  name: 'PartVehicleItem',
  components: {
    DetailIcon,
    PreviewImageModal
  },
  data(): PartVehicleItemProps {
    return {
      checked: this.vehicle.checked,
      showPreviewModal: false,
      previewImg: []
    };
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.$bus.$on('single-check-part-vehicle', this.singleCheckPartVehicle);

    this.$bus.$on('clear-check-part-vehicle', this.clearCheckPartVehicle);

    this.$bus.$on('calculate-img', this.calculateImg);
  },
  mounted() {
    this.calculateImg();
  },
  methods: {
    calculateImg() {
      const imgs: any[] = Array.from(
        document.querySelectorAll('.p-img-container')
      );

      imgs.forEach(e => {
        if (e.parentElement) {
          e.style.height = `${(e.parentElement?.offsetWidth * 5) / 8}px`;
        }
      });
    },
    clearCheckPartVehicle() {
      this.checked = false;
    },
    singleCheckPartVehicle(id) {
      if (this.vehicle.id !== id) {
        this.checked = false;
      } else {
        this.checked = !this.checked;
      }
    },
    handleChecked() {
      this.$bus.$emit('single-check-part-vehicle', this.vehicle.id);

      this.$emit('checked', this.vehicle, !this.checked);
    },
    getImgSrc() {
      let res = '';

      const imgs = (this.vehicle.showImg || '').split(',').filter(s => s);

      if (imgs.length > 0) {
        res = `${baseFileUrl}${imgs[0]}`;
      }

      return res;
    },
    handleCatalog() {
      this.$router.push(
        `/catalogue/${this.vehicle.id}?model=${this.vehicle.modelNum || ''}`
      );
    },
    handleMovingPart() {
      this.$router.push(`/spare-part/${this.vehicle.id}`);
    },
    handleImg() {
      this.previewImg.push(
        this.vehicle.attributeImg ? baseFileUrl + this.vehicle.attributeImg : ''
      );
      this.showPreviewModal = true;
    },
    handleAfterImgModalClose() {
      this.previewImg = [];
      this.showPreviewModal = false;
    }
  }
});
</script>

<style lang="scss" scoped>
.item-container {
  border-radius: 1px;
  border: 1px solid $secondary-color2;

  &:hover {
    border: 1px solid $primary-color;
    transition: border 0.5s;
  }

  .check-container {
    padding: 12px 0 12px 20px;
  }

  .img-container {
    cursor: pointer;

    img {
      display: inline-block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .no-img {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .item-info {
    background-color: $secondary-color1;
    padding: 14.5px 20px;
    display: flex;
    align-items: center;

    .name {
      font-weight: bold;
      margin-right: 20px;
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: $content-fontsize;
    }

    .detail {
      color: $primary-color;
      font-size: 15px;
      cursor: pointer;

      .icon {
        margin-right: 10px;
      }
    }
  }

  .item-action {
    padding: 20px;
    display: flex;
    align-items: center;

    &::v-deep(.ant-btn) {
      flex: 1;
      &:first-child {
        margin-right: 20px;
      }
    }
  }
}
</style>
